import { computed } from 'vue';

export const useSubjectOptions = () =>
  computed(() => [
    { label: 'Maths and English', value: 'mathsAndEnglish' },
    { label: 'Maths', value: 'maths' },
    { label: 'English', value: 'english' }
  ]);
